// extracted by css-extract-rspack-plugin
export default {"dialogBody":"ExperimentsDialog-module__dialogBody__p9nIm","experimentsInput":"ExperimentsDialog-module__experimentsInput__l4wHq"};